import React, { useState } from 'react';
import HeroSlider from '../components/HeroSlider';
import ProductCard from '../components/ProductCard';
import { FeaturesSection, TelegramCTA } from '../components/Sections';
import { PRODUCTS, CATEGORIES } from '../data/mock';
import { Link } from 'react-router-dom';
import { ArrowRight, Flame, Tag } from 'lucide-react';
import Seo, { SITE_URL } from '../components/Seo';

const Home = () => {
  const [tab, setTab] = useState('all');
  const featured = (tab === 'all' ? PRODUCTS : PRODUCTS.filter(p => p.category === tab)).slice(0, 16);
  const promos = PRODUCTS.filter(p => p.badge === 'Promocja');

  return (
    <>
      <Seo
        title="AlphaPro Genetics | Katalog produktów"
        description="AlphaPro Genetics — katalog produktów, kategorii oraz informacji zakupowych. Zobacz dostępne produkty i skontaktuj się przez Telegram."
        path="/"
        structuredData={{
          '@context': 'https://schema.org',
          '@graph': [
            { '@type': 'Organization', name: 'AlphaPro Genetics', url: SITE_URL, logo: `${SITE_URL}/favicon.svg` },
            { '@type': 'WebSite', name: 'AlphaPro Genetics', url: SITE_URL, inLanguage: 'pl-PL' },
          ],
        }}
      />
      <HeroSlider />

      {/* Category pills */}
      <section className="bg-white border-b border-blue-100 sticky top-[105px] lg:top-[105px] z-30 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-4 py-3 overflow-x-auto">
          <div className="flex items-center gap-2 min-w-max">
            {CATEGORIES.map(c => (
              <button
                key={c.id}
                onClick={() => setTab(c.id)}
                className={`px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition ${tab === c.id ? 'bg-blue-600 text-white shadow-md shadow-blue-200' : 'bg-blue-50 text-slate-700 hover:bg-blue-100'}`}
              >
                {c.name}
              </button>
            ))}
            <div className="w-px h-6 bg-blue-100 mx-2" />
            <Link to="/sklep" className="px-4 py-2 rounded-full text-sm font-semibold text-blue-600 hover:bg-blue-50 whitespace-nowrap flex items-center gap-1">
              Cały sklep <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Featured products - GŁÓWNA EKSPOZYCJA */}
      <section className="max-w-7xl mx-auto px-4 py-8 sm:py-10">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
              Sterydy, peptydy i suplementy
            </h2>
            <p className="text-sm text-slate-500 mt-1">Wszystkie produkty z magazynu - oryginalne i sprawdzone</p>
          </div>
          <Link to="/sklep" className="hidden sm:inline-flex items-center gap-1 text-blue-600 hover:text-blue-700 font-semibold text-sm">
            Zobacz wszystkie <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
          {featured.map(p => <ProductCard key={p.id} product={p} />)}
        </div>

        <div className="text-center mt-8">
          <Link to="/sklep" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-semibold shadow-lg shadow-blue-200 transition">
            Więcej produktów <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      {/* Promotions */}
      {promos.length > 0 && (
        <section className="bg-gradient-to-b from-blue-50/40 to-white py-10">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-blue-500 to-sky-400 flex items-center justify-center shadow-md shadow-blue-200">
                <Flame className="w-5 h-5 text-white" />
              </div>
              <div>
                <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">Promocje</h2>
                <p className="text-sm text-slate-500">Najlepsze oferty tygodnia</p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
              {promos.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          </div>
        </section>
      )}

      <FeaturesSection />
      <TelegramCTA />
    </>
  );
};

export default Home;
